
import React, { useCallback } from "react"
import { useDrop, useDrag } from "react-dnd"
import update from "immutability-helper"

export const DnDGroupingContainer = ({
  groupedColumns,
  setGrouping,
  columns
}) => {
  const findCard = useCallback(
    id => {
      const card = groupedColumns.filter(c => c === id)[0]
      return {
        card,
        index: groupedColumns.indexOf(card)
      }
    },
    [groupedColumns]
  )
  const moveCard = useCallback(
    (id, atIndex) => {
      const { card, index } = findCard(id)
      setGrouping(
        update(groupedColumns, {
          $splice: [
            [index, 1],
            [atIndex, 0, card]
          ]
        })
      )
    },
    [findCard, groupedColumns, setGrouping]
  )
  const removeCard = useCallback(
    id => {
      setGrouping(groupedColumns.filter(c => c !== id))
    },
    [groupedColumns, setGrouping]
  )
  const [, drop] = useDrop(() => ({ accept: "card" }))

  const [, dropcreate] = useDrop(
    () => ({
      accept: "column",
      drop(draggedColumn) {
        groupedColumns.includes(draggedColumn.id)
          ? setGrouping([...groupedColumns])
          : setGrouping([...groupedColumns, draggedColumn.id])
      }
    }),
    [groupedColumns]
  )
  return (
    <div ref={dropcreate} className="py-2 px-3 rounded">
      <div
        ref={drop}
        className="d-flex gap-2 p-2"
        style={{
          borderRadius: "5px",
          border: "1px dashed #ccc"
        }}
      >
        {groupedColumns.length ? (
          groupedColumns.map(card => {
            return(
            <Card
              key={card}
              id={`${card}`}
              text={columns.filter(c => c.id === card)[0].columnDef.header}
              moveCard={moveCard}
              findCard={findCard}
              removeCard={removeCard}
            />
          )})
        ) : (
          <span>Arrastre las Columnas Para Agrupar</span>
        )}
      </div>
    </div>
  )
}

const Card = ({ id, text, moveCard, findCard, removeCard }) => {
  const originalIndex = findCard(id).index
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: "card",
      item: { id, originalIndex },
      collect: monitor => ({
        isDragging: monitor.isDragging()
      }),
      end: (item, monitor) => {
        const { id: droppedId, originalIndex } = item
        const didDrop = monitor.didDrop()
        if (!didDrop) {
          moveCard(droppedId, originalIndex)
        }
      }
    }),
    [id, originalIndex, moveCard]
  )
  const [, drop] = useDrop(
    () => ({
      accept: "card",
      hover(item) {
        if (item?.id !== id) {
          const { index: overIndex } = findCard(id)
          moveCard(item?.id, overIndex)
        }
      }
    }),
    [findCard, moveCard]
  )
  const opacity = isDragging ? 0 : 1
  return (
    <div
      ref={node => drag(drop(node))}
      className="d-flex bg-light"
      style={{
        padding: "0.5rem 1rem",
        borderRadius: "5px",
        cursor: "move",
        opacity
      }}
    >
      <span className="align-self-center mr-2">
        {text ?? id}
      </span>
      <button
        type="button"
        className="btn btn-sm btn-brand ms-3"
        onClick={() => removeCard(id)}
      >
        X
      </button>
    </div>
  )
}
